var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value.minimum || !!_vm.value.maximum,
        label: "年齢",
        half: "",
      },
    },
    [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.minimum,
              expression: "value.minimum",
            },
          ],
          staticClass: "boss-input-select",
          class: { "is-invalid-input": _vm.isInvalid },
          attrs: { "data-test": "select-age-gte" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.value,
                "minimum",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        _vm._l(_vm.ageOptions, function (age, i) {
          return _c("option", { key: i, domProps: { value: age } }, [
            _vm._v("\n      " + _vm._s(age) + "\n    "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("span", [_vm._v("歳")]),
      _vm._v("\n  〜\n  "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.maximum,
              expression: "value.maximum",
            },
          ],
          staticClass: "boss-input-select",
          class: { "is-invalid-input": _vm.isInvalid },
          attrs: { "data-test": "select-age-lte" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.value,
                "maximum",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            },
          },
        },
        _vm._l(_vm.ageOptions, function (age, i) {
          return _c("option", { key: i, domProps: { value: age } }, [
            _vm._v("\n      " + _vm._s(age) + "\n    "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("span", [_vm._v("歳")]),
      _vm._v(" "),
      _vm.isInvalid
        ? _c("validation-label", {
            attrs: {
              label: "正しい大小関係で範囲を入力してください。",
              "data-test": "validation",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }